import React, { useState, useEffect } from "react";
import {
  BaseButtons,
  TextInputField,
} from "../../../../../../../../../../components/atoms";

const LineItemCard = ({
  data,
  statusCheck,
  EditQty,
  index,
  onRemoveClick,
  storeId,
  isPosCheckREcieve,
  display,
  isPos,
  isTransferDocLine,
  isInvoice,
  isPointOfSale,
}) => {
  const [qty, setQty] = useState(null);
  const [baseQty, setBaseQty] = useState(null);

  const [isSaved, setIsSaved] = useState(null);

  const [expectedAmount, setExpectedAmount] = useState(0);

  const NameAssemble = ({ product }) => {
    if (product) {
      let name =
        product.product.productName +
        " | " +
        product.product.productSubType +
        " | " +
        product.product.thcType +
        " | " +
        product.product.thcContent;
      return name;
    }
  };

  useEffect(() => {
    if (data) {
      if (!isPointOfSale) {
        setQty(data.qtyCard.qty);
        setBaseQty(data.qtyCard.qty);
      }

      if (
        (display && display.status === "in-transit") ||
        display.status === "complete"
      ) {
        setExpectedAmount(data.qtyCard.expected);
        setQty(data.qtyCard.qty);
      }
    }
  }, [data]);
  return (
    <div
      style={{
        width: "100%",
        height: isInvoice ? 50 : isTransferDocLine ? 50 : 85,
        borderRadius: isTransferDocLine ? 0 : 10,
        overflow: "hidden",
        borderStyle: isTransferDocLine ? "none" : "solid",
        borderWidth: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        position: "relative",
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!isTransferDocLine ? (
          <img
            src={data.product.imageUrl}
            alt="product"
            style={{ height: "100%" }}
          />
        ) : null}
      </div>
      <div style={{ marginLeft: 20, fontSize: isTransferDocLine ? 10 : 14 }}>
        {NameAssemble({ product: data })}
      </div>
      <div style={{ flex: 1 }} />
      {isPosCheckREcieve ||
      display.status === "complete" ||
      (display.status === "recieved" && !isInvoice) ? (
        <TextInputField
          type={"number"}
          labelTitle="EXPECTED"
          invert={true}
          mini={true}
          height={20}
          marginTop={-5}
          value={expectedAmount}
          size={isTransferDocLine ? 40 : 80}
          // onChange={(e) => setQty(e.target.value)}
          readOnly={true}
          fontFamily={"Arial"}
          fontsize={isTransferDocLine ? 10 : 10}
          fontsizeLabel={isTransferDocLine ? 8 : 10}
          paddingBottomTextBox={isTransferDocLine ? true : false}
          paddingTopTextBox={isTransferDocLine ? true : false}
        />
      ) : null}
      {isPosCheckREcieve ? <div style={{ minWidth: 10 }} /> : null}
      {isInvoice && !isPointOfSale ? (
        <div
          style={{
            fontSize: 10,
            display: "flex",
            alignItems: "center",
            maxWidth: 200,
            minWidth: 80,
          }}
        >
          <div style={{ fontSize: 8, marginRight: 10, marginLeft: 20 }}>
            <div style={{ marginBottom: 2, width: 60 }}>
              R {data ? Number(data.product.baseCostPrice).toFixed(2) : null}
            </div>
            <div
              style={{
                fontWeight: "bold",
                opacity: 0.6,
                color: "#A4A5A5",
                width: "100%",
              }}
            >
              {" "}
              price
            </div>
          </div>
          <div style={{ fontSize: 8, marginRight: 10, width: 60 }}>
            <div style={{ marginBottom: 2 }}>
              {data ? Number(data.qtyCard.qty) : null}
            </div>
            <div
              style={{
                fontWeight: "bold",
                opacity: 0.6,
                color: "#A4A5A5",
                width: "100%",
              }}
            >
              qty
            </div>
          </div>
          <div style={{ fontSize: 8, marginRight: 20, width: 60 }}>
            <div style={{ marginBottom: 2 }}>
              R{" "}
              {data
                ? Number(
                    Number(data.qtyCard.qty).toFixed(2) *
                      Number(data.product.baseCostPrice).toFixed(2)
                  ).toFixed(2)
                : null}
            </div>
            <div
              style={{
                fontWeight: "bold",
                opacity: 0.6,
                color: "#A4A5A5",
                width: "100%",
              }}
            >
              {" "}
              qty total
            </div>
          </div>
        </div>
      ) : null}
      <TextInputField
        type={"number"}
        labelTitle="QTY"
        invert={true}
        mini={true}
        height={isInvoice ? 20 : 20}
        marginTop={-5}
        value={isPointOfSale ? qty : isTransferDocLine ? (qty ? qty : "") : qty}
        onChange={(e) => setQty(e.target.value)}
        readOnly={!statusCheck}
        size={50}
        fontFamily={"Arial"}
        placeholder={" "}
        fontsize={isTransferDocLine ? 10 : 10}
        fontsizeLabel={isTransferDocLine ? 8 : 10}
        paddingBottomTextBox={isTransferDocLine ? true : false}
        paddingTopTextBox={isTransferDocLine ? true : false}
      />
      <div style={{ minWidth: 20 }} />
      {statusCheck && !isTransferDocLine ? (
        <BaseButtons
          label={isSaved ? "EDIT" : "SAVE EDIT"}
          mini={true}
          borderRadius={8}
          height={40}
          marginTopFalse={true}
          marginRight={20}
          onClick={
            isSaved
              ? () => setIsSaved(false)
              : () => {
                  EditQty({
                    idIndex: index,
                    qty: qty,
                    display: display.status,
                  });
                  setIsSaved(true);
                }
          }
          disable={qty !== baseQty ? false : true}
        />
      ) : null}

      {(statusCheck && !isPos) || !isTransferDocLine ? (
        display &&
        (display.status === "in-transit" ||
          display.status === "complete" ||
          display.status === "recieved") ? null : (
          <BaseButtons
            label={"REMOVE"}
            mini={true}
            borderRadius={8}
            height={40}
            marginTopFalse={true}
            marginRight={20}
            onClick={onRemoveClick}
          />
        )
      ) : null}
      {isTransferDocLine ? (
        <div
          style={{
            width: "100%",

            position: "absolute",
            bottom: -1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "95%",
              height: 1,
              backgroundColor: "#B5BDC6",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default LineItemCard;
